import { Component, OnInit, OnDestroy } from '@angular/core';
import { Selectedproductquote } from '../../../../../model/selectedproductquote';
import { SelectedProductQuoteFTRP } from '../../../../../model/selectedProductQuoteFTRP';
import { SelectedProductQuoteCORP } from '../../../../../model/selectedProductQuoteCORP';
// import { PersonalDetails } from '../../../../../model/ngrx/personal-details.model';
import * as UserDataConfig from '../../../config/user-data.config';
import { Router, ActivatedRoute } from '@angular/router';
import { Store } from '@ngrx/store';
import { Observable, Subscription } from 'rxjs';
import { AppState } from '../../../../../store/state/app.state';
import { UntypedFormGroup, UntypedFormBuilder } from '@angular/forms';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { OutputDetailsService, ButtonService, UtilService, SERVICE_END_POINT, QuoteDataCaptureService, DealPartnerFunctionalityService, AnalyticsService } from 'src/app/shared';
import { AlertModal } from 'src/app/model/alert';
import { ApplicationDataCaptureService } from '../../../../../shared/services/api-services/application-datacapture.service';
import * as RefNoActions from '../../../../../store/actions/reference-number.actions';
import * as HealthRecordsActions from '../../../../../store/actions/health-records.actions';
import * as beneficiaryDetailsActions from '../../../../../store/actions/beneficiary-details.actions';
import * as ClearToApplyActions from '../../../../../store/actions/clear-to-apply.actions';
import * as DepHealthRecordsActions from '../../../../../store/actions/dep-health-records.actions';
import * as paymentDetailsActions from '../../../../../store/actions/payment-details.actions';
import * as yourDependantDetailsActions from '../../../../../store/actions/your-dependant-details.actions';
import * as YourPensionSavings from '../../../../../store/actions/your-pension-savings.actions';
import * as yourPersonalDetailsActions from '../../../../../store/actions/your-personal-details.actions';
import * as yourProductApplicationActions from '../../../../../store/actions/your-product-application.actions';
import * as YourLumpSumActions from '../../../../../store/actions/your-lump-sum-allowances.actions';
import { PlatformLocation } from '@angular/common';
import { SelectedGMPQuote } from '../../../../../model/selectedGMPQuote';
import { quoteLevelConstants } from '../../../../../shared/constants/attribute-values.constants';
import { STORE_VAL } from 'src/app/shared/constants/store-val.constant';


@Component({
  selector: 'app-product-quote',
  templateUrl: './product-quote.component.html',
  styleUrls: ['./product-quote.component.scss']
})
//   enum IncomeFrequency {
//     Monthly = 'M',
//     Yearly = 'Y',
//     'In Advance' = 'A',
//     [In Arrears] = 'B',
// }
export class ProductQuoteComponent implements OnInit, OnDestroy {

  Selectedproductquote: Selectedproductquote;
  SelectedProductQuoteFTRP: SelectedProductQuoteFTRP;
  SelectedProductQuoteCORP: SelectedProductQuoteCORP;
  public contentData;
  public isApplySelected = false;
  public productQuoteForm: UntypedFormGroup;
  ProductQuoteErrorValidatorFlag = false;
  // protected  quoteDataCaptureStore: Observable<any[]>;
  protected resposeJsonQuoteCaptureStore: {};
  public approxQuotationTime;
  protected productCms;
  protected selectedCard: {};
  public resultQuote: {};
  public selectedProductCode: string;
  private subscripSaveProgress: Subscription;
  private subscriptn: Subscription;
  // public personalDetailsStore: Obse
  // public personalDetailsStore: Observable<PersonalDetails[]>;
  // public personalDetails: {};
  public loginDetail: any;
  public pdfUrlArray;
  private downloadAllFlag = false;
  public showProductComparison = false;
  loadingFlag: boolean = false;
  loadingPDFFlag: boolean = false;
  applyFlag: boolean = false;
  pdfAlertModalConfig: AlertModal;
  displayAlert = false;
  public noWarningMSg: boolean;
  public dontShowMsgAgain: boolean;
  isClickApply = false;
  quoteDependantDetails: {};
  taxFreeCashAmount;
  extTaxFreeCashAmount;
  totalTaxFreeCash;
  private CMSData;
  public allowtogoNextpage = false;
  selectedGMPQuote: SelectedGMPQuote;
  isGMPVal: string;
  constructor(private fb: UntypedFormBuilder, private activatedRoute: ActivatedRoute, private store: Store<AppState>,
    private outputDetailsService: OutputDetailsService, private router: Router,
    private buttonService: ButtonService,
    private quoteDatacaptureService: QuoteDataCaptureService,
    private applicationDatacaptureService: ApplicationDataCaptureService,
    private utilService: UtilService,
    private platform: PlatformLocation, private analyticsService: AnalyticsService) {
    history.pushState(null, null, location.href);
    platform.onPopState(() => {
      // this.applicationDatacaptureService.setBackClicked(true);
      // history.pushState(null, null, location.href);
      // this.allowtogoNextpage = true;
      // this.router.navigate(['/quote/your-saved-quotes']);
      // return false;
      history.go(1);
    });
    // window.onpopstate(null);


    this.contentData = this.activatedRoute.snapshot.data.contentData.productQuote;
    this.productCms = this.activatedRoute.snapshot.data.contentData.productChoice;
    this.approxQuotationTime = this.activatedRoute.snapshot.data.contentData.contentBottomNavigationBar.approxQuotationTime;
    store.select(STORE_VAL.quote_result).subscribe(res => {
      if (res.length > 0) {
        this.resposeJsonQuoteCaptureStore = res[0];
        this.resultQuote = this.resposeJsonQuoteCaptureStore;
        let TFCAmount = (this.resultQuote['totalTaxFreeCashAmount']) ? this.resultQuote['totalTaxFreeCashAmount'] : 0;
        let TFCExtAmount = (this.resultQuote['totalExtTaxFreeCashAmount']) ? this.resultQuote['totalExtTaxFreeCashAmount'] : 0;
        let TFCTotalAmount = TFCAmount + TFCExtAmount
        this.analyticsService.orderTrack({ internalReferenceDCJ: this.resultQuote['quoteRefNo'],quoteReference:this.resultQuote['padsRefNo']});
        this.analyticsService.productsTrack({'channel': this.resultQuote['source'],'annualIncome':this.resultQuote['annualIncome'],'startDate':this.resultQuote['startDate'],
                                             'incomeRegularity':this.resultQuote['paymentFrequency'],'incomeType':this.resultQuote['paymentAdvance'],
                                             'incomeIncreaseOption':this.resultQuote['escalationType'],'incomeIncreaseValue':this.resultQuote['escalationRate'],
                                             'incomeProtectionOption':this.resultQuote['vpIndicator'],'incomeProtectionValue':this.resultQuote['vpPercentage'],
                                             'guaranteedIncomePeriod':this.resultQuote['guaranteedTerm'],'dependantIncome':this.resultQuote['secondLifePensionPercentage'],
                                             'lumpSumOption':this.resultQuote['taxFreeCashAmountPercent'],'lumpSumValue':TFCTotalAmount,
                                             'purchasePotValue':this.resultQuote['netAmount'],'monthlyIncome':this.resultQuote['annualIncome'] && this.resultQuote['paymentFrequency'] == 'M' ? this.resultQuote['annualIncome'] / 12 : 0,
                                            });
        if(this.resultQuote['compQuote'] && this.resultQuote['compQuote']['errorMessage'])
          this.analyticsService.errorAnalyticsTrack({formErrorMessage: this.resultQuote['compQuote']['errorMessage'], formErrorType: 'Validation Errors', formErrorDetail: '0', formErrorCount: 1 })
      }
    });
    store.select(STORE_VAL.quote_calculation).subscribe(res => {
      if (res.length > 0) {
        this.resposeJsonQuoteCaptureStore = res[0];
        // this.selectedCard = this.resposeJsonQuoteCaptureStore['benefitVariants'].find(b => b.selected === true)['quickQuoteModel'];
        const allObject = this.resposeJsonQuoteCaptureStore['benefitVariants'].find(b => b.selected === true);
        // tslint:disable-next-line: max-line-length
        const startDate = allObject.startDate ? allObject.startDate : null;
        this.selectedCard = { ...allObject.quickQuoteModel, ...allObject.benefitBasisModel, ...allObject.quoteBasisModel, startDate };
        if (this.resposeJsonQuoteCaptureStore && this.resposeJsonQuoteCaptureStore['benefitBasis'].length >= 1
          && this.resposeJsonQuoteCaptureStore['benefitBasis'][0]['netPensionFund']) {
          if (this.resultQuote && this.resultQuote['pensionFund']) {
            this.resultQuote = {...this.resultQuote, pensionFund: this.resposeJsonQuoteCaptureStore['benefitBasis'][0]['netPensionFund']};
          }
        }
      }
    });
    // this.personalDetailsStore = store.select('personalDetails');
    // this.personalDetailsStore.subscribe(res => {
    //   if (res.length > 0) {
    //     this.personalDetails = res[0];
    //   }
    // });

    this.store.select(STORE_VAL.loggedin_detail).subscribe(res => {
      if (res.length > 0) {
        this.loginDetail = res[0];
        let customerAge =  (this.loginDetail['customer'].dateOfBirth !='' &&  this.loginDetail['customer'].dateOfBirth !=null) ? this.loginDetail['customer'].dateOfBirth : '' ;
        let totalAge;
        if(customerAge) {
          totalAge  = (new Date().getFullYear()) - (Number(customerAge.split('/')[2]))
        }
       let personData =  { 
                             'age': (totalAge) ? totalAge : '',
                             'dateOfBirth': this.loginDetail['customer'].dateOfBirth, 
                             'gender': (this.loginDetail['customer'].gender && this.loginDetail['customer'].gender == 'M') ? 'Male': 'Female', 
                             'postcode': this.loginDetail['customer']['address'].postcode, 
                             'email': this.loginDetail['customer'].emailAddress,
                             'forename': this.loginDetail['customer'].forename,
                             'surname': this.loginDetail['customer'].surname,
                             'mobilePhone': this.loginDetail['customer'].mobilePhone,
                             'homePhone': this.loginDetail['customer'].homePhone,
                             'quoteEmail': (this.loginDetail['customer'].internalSoftOptInInd == 'Y') ? 'Y' : (this.loginDetail['customer'].internalSoftOptInInd == 'N') ? 'N': ''

                            }
                            this.analyticsService.customerTrack({ ...personData});  
      }
    });


    // capturing quote journey dependant's details
    store.select(STORE_VAL.dependant_details).subscribe(res => {
      if (res.length > 0) {
        this.quoteDependantDetails = res[0];
      }
    });


  }

  ngOnInit() {
    this.GetCMSDataServiceMapper();
    // tslint:disable-next-line: max-line-length
    this.subscripSaveProgress = this.applicationDatacaptureService.invokeSaveFunction.subscribe((res) => {
      this.subscriptn = this.quoteDatacaptureService.postQuoteDataCapture(false).subscribe();
      this.allowtogoNextpage = true;
      if (res === 'yoursavedquote') {
        this.router.navigate(['quote/your-saved-quotes']);
      } else if (res === 'updatemyDetail') {
        this.router.navigate(['home/update-my-details']);
      }
    });
    this.pdfAlertModalConfig = this.contentData.pdfModalConfig;
    if (this.resultQuote) {
      this.selectedProductCode = this.productCms.products.find(p => p.productCode === this.resultQuote['product']).productCode;
      this.taxFreeCashAmount = (this.resultQuote['totalTaxFreeCashAmount']) ? this.resultQuote['totalTaxFreeCashAmount'] : 0;
      this.extTaxFreeCashAmount = (this.resultQuote['totalExtTaxFreeCashAmount']) ? this.resultQuote['totalExtTaxFreeCashAmount'] : 0;
      this.totalTaxFreeCash = this.taxFreeCashAmount + this.extTaxFreeCashAmount;
      this.isGMPVal = this.resultQuote['isGMP'];
    }
    this.productQuoteForm = this.fb.group({
      chkApply: [null]
    });

    this.getData();
  }

  formatIncome(card) {
    let paymentFrequency;
    let paymentAdvance;
    let income;
    if (card.paymentFrequency === 'M') {
      paymentFrequency = 'Monthly';
    } else if (card.paymentFrequency === 'Y') {
      paymentFrequency = 'Yearly';
    } else if (card.paymentFrequency === 'Q') {
      paymentFrequency = 'Quarterly';
    } else if (card.paymentFrequency === 'H') {
      paymentFrequency = 'Half-yearly';
    }
    if (card.paymentAdvance === 'A') {
      paymentAdvance = 'In advance';
    } else if (card.paymentAdvance === 'B') {
      paymentAdvance = 'In arrears';
    }
    income = paymentFrequency + ' / ' + paymentAdvance;
    return income;
  }
  formatIncomeIncrease(card) {
    let incomeIncrease;
    switch (card.escalationType) {
      case 'N':
        incomeIncrease = 'No';
        break;
      case 'R':
        // incomeIncrease = 'Yes / RPI';
        incomeIncrease = 'RPI';
        break;
      case 'L':
        incomeIncrease = 'LPI';
        break;
      default:
        incomeIncrease = 'Fixed' + ' / ' + card.escalationRate + this.contentData.percentage;
        // incomeIncrease = 'Fixed' + ' / ' + card.escalationRate;
        break;
    }
    return incomeIncrease;
  }
  formatGuarantedPaymentPeriod(numInYear) {
    return (!numInYear || numInYear === 0) ? '0' : (numInYear === 1) ? '1 year' : (numInYear + ' years');
  }

  getInteger(annuitantPension) {
    const integerString = String(annuitantPension);
    return integerString.split('.')[0];
  }

  getFraction(vpamount) {
    let decimalString = String(vpamount);
    decimalString = (decimalString && decimalString.indexOf('.') > -1) ? decimalString.split('.')[1] : '';
    return decimalString.length > 0 ? decimalString : '00';
  }

  backToMyQuote() {
    alert('Back To My Quote button is clicked!!!');
  }
  onApplyCheckChange() {
    this.ProductQuoteErrorValidatorFlag = !this.isApplySelected;
  }
  applyQuote() {
    // if(this.isApplySelected)
    this.isClickApply = true;
    this.ProductQuoteErrorValidatorFlag = !this.isApplySelected;
    this.store.dispatch(new ClearToApplyActions.RemoveClearToApply(0));
    this.store.dispatch(new yourPersonalDetailsActions.RemoveYourPersonalDetails(0));
    this.store.dispatch(new HealthRecordsActions.RemoveHealthRecords(0));
    this.store.dispatch(new yourDependantDetailsActions.RemoveYourDependantDetails(0));
    this.store.dispatch(new DepHealthRecordsActions.RemoveDepHealthRecords(0));
    this.store.dispatch(new YourPensionSavings.RemovePensionSavings(0));
    this.store.dispatch(new beneficiaryDetailsActions.RemoveBeneficiaryDetails(0));
    this.store.dispatch(new paymentDetailsActions.RemovePaymentDetails(0));
    this.store.dispatch(new yourProductApplicationActions.RemoveYourProductApplication(0));

    if (this.isApplySelected && this.applyFlag) {
      if (!this.loginDetail.customer.registrationStatus) {
        //user is not authenticated       
       this.allowtogoNextpage = true;
       this.router.navigate(['apply/user-login-required']);
      } else {
        this.ProductQuoteErrorValidatorFlag = !this.isApplySelected;
        this.applicationDatacaptureService.createApplication([this.resultQuote["quoteRefNo"]]).subscribe(res => {
        this.store.dispatch(new RefNoActions.RemoveReferenceNumber(0));
        this.store.dispatch(new RefNoActions.AddReferenceNumber({
          editMode: false,
          formSessionId: res['formSessionId'],
          quoteNumberFlag: 1,
          quoteReferenceNumber: null,
          applicationRefNumber: res['applicationId']
        }));

        /** Sai :: As a part of DTC-292 , we need to hide certain pages if the prodct selected is either
         * FTRP or CORP, the below condition checks for product code and refreshes the breadcrumbs accordingly.
         */
        if (this.selectedProductCode != null) {
          if (this.selectedProductCode === 'H' || this.selectedProductCode === 'G') {
            this.utilService.refreshBreadcrumb({ hideApplyPagesForFTRPCorp: false });
          } else if (this.selectedProductCode === 'C') {
            // checks for (LTA + secondLife) and refreshes the breadcrumbs accordingly.
            if (res && res['secondLife'] && res['secondLife']['dateOfBirth'] !== null) {
              if (this.isGMPVal === quoteLevelConstants.radioToggleYesNo.yes
                && !DealPartnerFunctionalityService.gmpMaritalCheck(res['customer']['maritalStatus'])) {
                this.utilService.refreshBreadcrumb({ hideDependantApplyDetails: true });
              } else if (this.isGMPVal === quoteLevelConstants.radioToggleYesNo.yes
                && DealPartnerFunctionalityService.gmpMaritalCheck(res['customer']['maritalStatus'])) {
                this.utilService.refreshBreadcrumb({ hideGMPDependantApplyDetails: true });
              } else if (DealPartnerFunctionalityService.isGARProduct(this.resultQuote['garIndicator'])
                && DealPartnerFunctionalityService.gmpMaritalCheck(res['customer']['maritalStatus'])
                && DealPartnerFunctionalityService.spouseBenefit(res['quoteFundInfo'][0], res['secondLife'])
                && res['cedingPension'][0]['productCode'] && res['cedingPension'][0]['productCode'] === "J10") {
                this.utilService.refreshBreadcrumb({ hideDependantApplyDetails: true });
              } else {
                this.utilService.refreshBreadcrumb({ hideDependantApplyDetails: false });
              }
            } else {
              this.utilService.refreshBreadcrumb({ hideDependantApplyDetails: true });
            }
          }
        }
        // TODO: as per DTC-292 , based on showBeneficiary value we need to hide beneficiary details
        if (res && (res['showBeneficiary'] && res['showBeneficiary'] === true)) {
          this.utilService.refreshBreadcrumb({ hideBeneficiaryApplyDetails: false });
        } else {
          this.utilService.refreshBreadcrumb({ hideBeneficiaryApplyDetails: true });
        }
        this.allowtogoNextpage = true;
        this.router.navigate(['/apply/clear-to-apply']);
      });
     }
    }
  }

  handleDownloadAll() {
    const productQuote = this.selectedProductCode === 'C' ? this.Selectedproductquote :
      (this.selectedProductCode === 'H' ? this.SelectedProductQuoteFTRP : this.SelectedProductQuoteCORP);
    this.openPersonalisedQuote((this.isGMPVal === 'Y' ? this.selectedGMPQuote : productQuote), 'downloadAll');
  }

  downloadAll(pdfUrlArray) {
    this.pdfUrlArray = pdfUrlArray;
  }

  goBack() {
    this.allowtogoNextpage = true;
    if(this.loginDetail.customer.registrationStatus == true) {
      this.router.navigate(['/quote/your-saved-quotes']);
    }
  }

  checkWOMEnable = () => {
    if (this.resultQuote) {
      const quote = this.resultQuote;
      if (quote['indicative'] && quote['indicative'] === 'Y') {
        this.showProductComparison = false;
      } else {
        this.showProductComparison = true;
      }
    }
  }
  openPersonalisedQuote = (productQuote, type?: string) => {
    if (this.loginDetail && this.loginDetail.customer) {
      if (!type) {
        this.loadingPDFFlag = true;
        this.loadingFlag = false;
      } else {
        this.loadingFlag = true;
        this.loadingPDFFlag = false;
      }
      const customerDetail = this.loginDetail.customer;
      const recipientName = (customerDetail.title ? customerDetail.title + ' ' : '') +
        (customerDetail.forename ? customerDetail.forename + ' ' : '') +
        (customerDetail.middleName ? customerDetail.middleName + '  ' : '') +
        (customerDetail.surname ? customerDetail.surname : '');
      const inputParam = {
        addressLine1: customerDetail.address ? customerDetail.address.line1 : '',
        addressLine2: customerDetail.address ? customerDetail.address.line2 : '',
        addressLine3: customerDetail.address ? customerDetail.address.line3 : '',
        addressLine4: customerDetail.address ? customerDetail.address.line4 : '',
        countryCode: customerDetail.address ? customerDetail.address.countryCode : '',
        lifeTimeAllowanceFlag: 'N',
        isSendToTrustee: 'N',
        thirdParty: { partyType: '', address: {} },
        outputMethod: this.contentData.localPrint,
        packCode: '',
        packCodeDescription: '',
        padsRefNo: (productQuote && productQuote.padsRefNo) ?
          productQuote.padsRefNo : '',
        quoteRef: (productQuote && productQuote.quoteRefNo) ?
          productQuote.quoteRefNo : '',
        postcode: customerDetail.address ? customerDetail.address.postcode : '',
        recipientName,
        isGMP: this.isGMPVal === 'Y' ? this.isGMPVal : 'N'
      };
      this.outputDetailsService.generateRiskWarning(inputParam).subscribe((data: any) => {
        // this.successMessage = true;
        if (data) {
          this.applyFlag = true;
        } else {
          this.applyFlag = false;
          this.displayAlert = true; //
        }
        this.buttonService.handleButtonLoaderFlag({ flag: false });
        if (this.loadingFlag) {
          this.loadingFlag = false;
        }
        if (this.loadingPDFFlag) {
          this.loadingPDFFlag = false;
        }
        const file = new Blob([data], { type: 'application/pdf' });

        const nav = (window.navigator as any); 

        if (nav.msSaveOrOpenBlob) {
          nav.msSaveOrOpenBlob(file, 'Quote ref' + productQuote.padsRefNo + '.pdf');
          // if (this.lifeTimeAllowanceFlag != null && this.lifeTimeAllowanceFlag === 'Y') {
          //   nav.msSaveOrOpenBlob(file, 'Quote ref' + quoteRequestSearchModelsWithoutLCP[i].quoteResultModel.padsRefNo
          //     + ' ' + 'Z32.pdf');
          // }
          // else {
          //   nav.msSaveOrOpenBlob(file, 'Quote ref' + quoteRequestSearchModelsWithoutLCP[i].quoteResultModel.padsRefNo
          //     + ' ' + quoteRequestSearchModelsWithoutLCP[i].packCode + '.pdf');
          // }
        } else {
          const fileURL = URL.createObjectURL(file);
          window.open(fileURL);
          this.applyFlag = true;
          this.displayAlert = false;
        }
        if (type && type === 'downloadAll') {
          window.open(this.pdfUrlArray[0], '_blank');
          window.open(this.pdfUrlArray[1], '_blank');
          window.open(this.pdfUrlArray[2], '_blank');
        }
        this.store.dispatch({ type: 'LOADING_ICON', loadingIcon: false });
      }, (err: HttpErrorResponse) => {
        this.applyFlag = true;
        this.displayAlert = true;
        this.loadingPDFFlag = false;
        if (err.error instanceof Error) {
          this.buttonService.handleButtonLoaderFlag({ flag: false });
          this.loadingFlag = false;
          //console.log('Client-side error occured.');
        } else {
          //console.log(err);
          this.buttonService.handleButtonLoaderFlag({ flag: false });
          this.loadingFlag = false;
          // this.successMessage = false;
          // this.store.dispatch({ type: 'LOADING_ICON', loadingIcon: false });
        }
      });
    }
  }
  alertPrimaryBtnClick() {
    this.closeModal();
  }
  alertSecondaryBtnClick() {
    this.closeModal();
  }
  closeModal() {
    this.displayAlert = false;
    this.noWarningMSg = (this.dontShowMsgAgain === true ? true : false);
  }
  dontShowUPMsgAgain(val) {
    this.dontShowMsgAgain = val;
  }
  /** Code block for CMS */
  GetCMSDataServiceMapper() {
    //console.log('changed value = ', this.contentData);
    const URL = SERVICE_END_POINT.higherEnvironment.CMS_YourProductQuote;
    this.utilService.getCMSData(URL).subscribe(res => {
      //console.log('2 GetCMSDataService => ', res);
      this.CMSData = res;
      if (this.CMSData) {
        /** In the line below we are over-writing the contentData object values with CMSData object values */
        this.contentData.downloadAllButton = this.CMSData.string_DownloadAllDocumentsCTALabel;
        this.contentData.applyButton = this.CMSData.string_ApplyCTALabel;
        this.contentData.decideYourQuoteText = this.CMSData.string_DecidedWithQuoteText;
        this.contentData.decideYourQuotLable = this.CMSData.string_DecidedWithQuoteTitle;
        this.contentData.whatnextLable = this.CMSData.string_WhatsNextTitle;
        this.contentData.expiryInText = this.CMSData.commonBlock.string_QuoteExpiresWording;
        this.contentData.whatNextText = this.CMSData.string_WhatsNextText;
        this.contentData.backBtn =  this.loginDetail.customer.registrationStatus == true ? 
                                      this.CMSData.commonBlock.string_BackToMyQuotesCTALabel : 
                                      this.CMSData.commonBlock.string_BackCTALabel;

        this.contentData.pdfModalConfig.title = this.CMSData.pdfBlock.string_PDFFailedErrorTitle;
        this.contentData.pdfModalConfig.content = this.CMSData.commonBlock.stringGroup_OpenDocumentErrorText;
        this.approxQuotationTime = this.CMSData.string_TakeFiveToTenMinsWording;
        this.contentData.indicativeResponseText = this.CMSData.string_IndMessage;
        //this.userInputDetail['buttonConfig'].name = this.CMSData.commonBlock.string_NextCTALabel;

      }
    });
  }
  /** End of code block for CMS */

  ngOnDestroy() {
    // if (this.subscriptn) {
    // this.subscriptn.unsubscribe();
    // }
    if (this.subscripSaveProgress) {
      this.subscripSaveProgress.unsubscribe();
    }
  }

  getData() {
    if (this.resultQuote && this.isGMPVal === quoteLevelConstants.radioToggleYesNo.yes) {
      const objProductQuote = {
        pensionFund: this.resultQuote['pensionFund'],
        startDate: this.resultQuote['startDate'],
        indicative: this.resultQuote['indicative'],
        income: this.formatIncome(this.resultQuote),
        totalTaxFreeCashAmount: this.totalTaxFreeCash,
        taxFreeCashAmountPercent: this.resultQuote['taxFreeCashAmountPercent'],
        quoteExpiry: this.resultQuote['quoteExpiry'],
        monthlyIncome: this.resultQuote['annualIncome'] ? this.resultQuote['annualIncome'] / 12 : 0,
        annualIncome: this.resultQuote['annualIncome'] ? this.resultQuote['annualIncome'] : 0,
        padsRefNo: this.resultQuote['padsRefNo'],
        paymentFrequency: this.resultQuote['paymentFrequency'],
        selectedProduct: this.resultQuote['product'],
        quoteRefNo: this.resultQuote['quoteRefNo'],
        productOptions: null,
        fundingSource: this.resultQuote['source'],
        requoteInd: this.resultQuote['requoteInd'],
        isGMP: this.isGMPVal,
        applicationId: this.resultQuote['applicationId']
      };
      this.selectedGMPQuote = objProductQuote;
      if (this.resultQuote['compQuote'] && this.resultQuote['compQuote']['consentIndicator'] === 'Y') {
        this.checkWOMEnable();
      } else {
        this.showProductComparison = false;
      }
    } else {
      if (this.selectedProductCode === 'C') {
        const objProductQuote = {
          pensionFund: (this.isGARCheck(this.resultQuote['garIndicator']) === true) ?
            this.resultQuote['totalFund'] : this.resultQuote['netAmount'],
          startDate: this.resultQuote['startDate'],
          indicative: this.resultQuote['indicative'],
          income: this.formatIncome(this.resultQuote),
          incomeIncrease: this.formatIncomeIncrease(this.resultQuote),
          totalTaxFreeCashAmount: this.totalTaxFreeCash,
          incomeDependent: this.resultQuote['secondLifePensionPercentage'] ? this.resultQuote['secondLifePensionPercentage'] : 0,
          guaranteedTerm: this.resultQuote['guaranteedTerm'],
          guarantedPaymentPeriod: this.formatGuarantedPaymentPeriod(this.resultQuote['guaranteedTerm']),
          valueProtection: this.resultQuote['vpPercentage'],
          valueProtectionAmount: this.resultQuote['vpAmount'],
          quoteExpiry: this.resultQuote['quoteExpiry'],
          monthlyIncome: this.resultQuote['annualIncome'] ? this.resultQuote['annualIncome'] / 12 : 0,
          annualIncome: this.resultQuote['annualIncome'] ? this.resultQuote['annualIncome'] : 0,
          padsRefNo: this.resultQuote['padsRefNo'],
          paymentFrequency: this.resultQuote['paymentFrequency'],
          selectedProduct: this.resultQuote['product'],
          fundingSource: (this.resultQuote['source']),
          quoteRefNo: this.resultQuote['quoteRefNo'],
          annuitantPension: 0,
          annuitantYearlyPension: 0,
          applicationId: this.resultQuote['applicationId'],
          productOptions: null,
          requoteInd: this.resultQuote['requoteInd'],
          applyQuoteInd: this.resultQuote['applyQuoteInd'],
          garIndicator: this.resultQuote['garIndicator'],
          taxFreeCashAmountPercent: this.resultQuote['taxFreeCashAmountPercent'],
          vpIndicator: this.resultQuote['vpIndicator']
          // annuitantPension: this.selectedCard['annuitantPension'] ? this.selectedCard['annuitantPension'] : 0,
          // annuitantYearlyPension: this.selectedCard['annuitantYearlyPension'] ? this.selectedCard['annuitantYearlyPension'] : 0
        };
        this.Selectedproductquote = objProductQuote;
        if (this.resultQuote['compQuote'] && this.resultQuote['compQuote']['consentIndicator'] === 'Y') {
          this.checkWOMEnable();
        } else {
          this.showProductComparison = false;
        }
      }
      if (this.selectedProductCode === 'H') {
        const objProductQuote = {
          pensionFund: this.resultQuote['netAmount'],
          //  startDate: this.resultQuote['startDate'],
          startDate: this.resultQuote['startDate'],
          indicative: this.resultQuote['indicative'],
          income: this.formatIncome(this.resultQuote),
          incomeIncrease: this.formatIncomeIncrease(this.resultQuote),
          totalTaxFreeCashAmount: this.totalTaxFreeCash,
          incomeDependent: this.resultQuote['secondLifePensionPercentage'] ? this.resultQuote['secondLifePensionPercentage'] : 0,
          guaranteedTerm: this.resultQuote['guaranteedTerm'],
          guaranteedTermIndicator: this.resultQuote['guaranteedTermIndicator'],
          guarantedPaymentPeriod: this.formatGuarantedPaymentPeriod(this.resultQuote['guaranteedTerm']),
          valueProtection: this.resultQuote['vpPercentage'],
          valueProtectionAmount: this.resultQuote['vpAmount'],
          quoteExpiry: this.resultQuote['quoteExpiry'],
          monthlyIncome: this.resultQuote['annualIncome'] ? this.resultQuote['annualIncome'] / 12 : 0,
          annualIncome: this.resultQuote['annualIncome'] ? this.resultQuote['annualIncome'] : 0,
          padsRefNo: this.resultQuote['padsRefNo'],
          paymentFrequency: this.resultQuote['paymentFrequency'],
          selectedProduct: this.resultQuote['product'],
          fundingSource: (this.resultQuote['source']),
          quoteRefNo: this.resultQuote['quoteRefNo'],
          annuitantYearlyPension: this.resultQuote['annualIncome'] ? this.resultQuote['annualIncome'] : 0,
          annuitantPension: this.resultQuote['annualIncome'] ? this.resultQuote['annualIncome'] / 12 : 0,
          annuitantMaturity: this.resultQuote['maturityValue'] ? this.resultQuote['maturityValue'] : 0,
          policyTerm: this.resultQuote['policyTerm'] ? this.resultQuote['policyTerm'] : 0,
          policyTermMonths: this.resultQuote['policyTermMonths'] ? this.resultQuote['policyTermMonths'] : 0,
          maturityAmount: this.resultQuote['maturityValue'] ? this.resultQuote['maturityValue'] : 0,
          initialAnnualIncome: this.resultQuote['annualIncome'] ? this.resultQuote['annualIncome'] : 0,
          giaCalculated: this.resultQuote['giaCalculated'] ? this.resultQuote['giaCalculated'] : null,
          applicationId: this.resultQuote['applicationId'],
          productOptions: null,
          requoteInd: this.resultQuote['requoteInd'],
          applyQuoteInd: this.resultQuote['applyQuoteInd']
        };
        this.SelectedProductQuoteFTRP = objProductQuote;
        this.showProductComparison = false;
      }
      if (this.selectedProductCode === 'G') {
        const objProductQuote = {
          pensionFund: this.resultQuote['netAmount'],
          //  startDate: this.resultQuote['startDate'],
          startDate: this.resultQuote['startDate'],
          indicative: this.resultQuote['indicative'],
          income: this.formatIncome(this.resultQuote),
          incomeIncrease: this.formatIncomeIncrease(this.resultQuote),
          totalTaxFreeCashAmount: this.totalTaxFreeCash,
          incomeDependent: this.resultQuote['secondLifePensionPercentage'] ? this.resultQuote['secondLifePensionPercentage'] : 0,
          guaranteedTerm: this.resultQuote['guaranteedTerm'],
          guarantedPaymentPeriod: this.formatGuarantedPaymentPeriod(this.resultQuote['guaranteedTerm']),
          valueProtection: this.resultQuote['vpPercentage'],
          valueProtectionAmount: this.resultQuote['vpAmount'],
          quoteExpiry: this.resultQuote['quoteExpiry'],
          monthlyIncome: this.resultQuote['annualIncome'] ? this.resultQuote['annualIncome'] / 12 : 0,
          annualIncome: this.resultQuote['annualIncome'] ? this.resultQuote['annualIncome'] : 0,
          padsRefNo: this.resultQuote['padsRefNo'],
          paymentFrequency: this.resultQuote['paymentFrequency'],
          selectedProduct: this.resultQuote['product'],
          fundingSource: (this.resultQuote['source']),
          quoteRefNo: this.resultQuote['quoteRefNo'],
          annuitantYearlyPension: this.resultQuote['annualIncome'] ? this.resultQuote['annualIncome'] : 0,
          annuitantPension: this.resultQuote['annualIncome'] ? this.resultQuote['annualIncome'] / 12 : 0,
          policyTerm: this.resultQuote['policyTerm'] ? this.resultQuote['policyTerm'] : 0,
          policyTermMonths: this.resultQuote['policyTermMonths'] ? this.resultQuote['policyTermMonths'] : 0,
          applicationId: this.resultQuote['applicationId'],
          productOptions: null,
          requoteInd: this.resultQuote['requoteInd'],
          applyQuoteInd: this.resultQuote['applyQuoteInd']
        };
        this.SelectedProductQuoteCORP = objProductQuote;
        this.showProductComparison = false;
      }
    }
  }
  isGARCheck(garIndicator: string) {
    if (garIndicator === quoteLevelConstants.garIndicators.yes || garIndicator === quoteLevelConstants.garIndicators.ignored
      || garIndicator === quoteLevelConstants.garIndicators.beaten || garIndicator === quoteLevelConstants.garIndicators.featured) {
      return true;
    }
    return false;
  }
}
